import { useLayoutEffect, useState } from "react";
import { flushSync } from "react-dom";

const CLAVE_TEMA = "titan-tema";

// Sin elección guardada se sigue al sistema. localStorage puede fallar en
// modo privado: entonces el tema simplemente no se recuerda.
function temaInicial() {
  try {
    const guardado = localStorage.getItem(CLAVE_TEMA);
    if (guardado === "dark" || guardado === "light") return guardado;
  } catch {}
  return window.matchMedia?.("(prefers-color-scheme: dark)").matches ? "dark" : "light";
}

// Tema claro/oscuro de toda la app, en <html data-theme>. Layout effect para
// aplicarlo antes del primer pintado y que no parpadee el tema claro.
export function useTema() {
  const [tema, setTema] = useState(temaInicial);

  useLayoutEffect(() => {
    document.documentElement.dataset.theme = tema;
  }, [tema]);

  const cambiarTema = (e) => {
    const nuevo = tema === "dark" ? "light" : "dark";
    try {
      localStorage.setItem(CLAVE_TEMA, nuevo);
    } catch {}

    const quieto = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!document.startViewTransition || quieto) {
      setTema(nuevo);
      return;
    }

    // El tema nuevo se abre en círculo desde el centro del botón
    const caja = e.currentTarget.getBoundingClientRect();
    const x = caja.left + caja.width / 2;
    const y = caja.top + caja.height / 2;
    const radio = Math.hypot(Math.max(x, innerWidth - x), Math.max(y, innerHeight - y));

    document
      .startViewTransition(() => flushSync(() => setTema(nuevo)))
      .ready.then(() => {
        document.documentElement.animate(
          { clipPath: [`circle(0px at ${x}px ${y}px)`, `circle(${radio}px at ${x}px ${y}px)`] },
          {
            duration: 620,
            easing: "cubic-bezier(0.22, 1, 0.36, 1)",
            pseudoElement: "::view-transition-new(root)"
          }
        );
      });
  };

  return [tema, cambiarTema];
}
